import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.867 6.749a1 1 0 0 0-.118.118A12.96 12.96 0 0 0 3 16c0 7.18 5.82 13 13 13 3.56 0 6.786-1.431 9.134-3.75a1 1 0 0 0 .117-.116A12.96 12.96 0 0 0 29 16c0-7.18-5.82-13-13-13-3.56 0-6.786 1.43-9.133 3.749m2.094.798A10.96 10.96 0 0 1 16 5c6.075 0 11 4.925 11 11 0 2.677-.957 5.132-2.547 7.04zm14.078 16.906A10.96 10.96 0 0 1 16 27C9.925 27 5 22.075 5 16c0-2.677.957-5.132 2.547-7.039z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconProhibit = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconProhibit);
export default Memo;
